import formatCurrency from '@/lib/formatMoney';
export default {
	methods: {
		formatMoney(number) {
			return formatCurrency(number);
		},
	},
};
